export const SHOW_MESSAGE = 'SHOW_MESSAGE';
// 消息数量
export const MESSAGE_COUNT = 'MESSAGE_COUNT';
// 未读消息统计obj,(上述并不是消息数量...)
export const NOTIFY_COUNT = 'NOTIFY_COUNT';
// 活动霸屏弹窗里的轮播图列表
export const ACTIVITY_ACTION = 'activityAction';
// 霸屏弹框状态
export const BAPING_ACTION = 'BAPING_ACTION'
// 推广费-小数点
export const DECIMAL_ACTION = 'DECIMAL_ACTION'
// 菜单 id 列表
export const ADD_MENU_ID = 'ADD_MENU_ID'
